import { z } from 'zod';

export const FinishTypeSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateFinishTypeSchema = z.object({
  name: z.string().min(1, 'Name is required'),
});

export const UpdateFinishTypeSchema = CreateFinishTypeSchema.partial();

export type FinishType = z.infer<typeof FinishTypeSchema>;
export type CreateFinishType = z.infer<typeof CreateFinishTypeSchema>;
export type UpdateFinishType = z.infer<typeof UpdateFinishTypeSchema>;
